import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    categoryLinkListWrapper: InjectableCss;
    categoryListWrapper: InjectableCss;
}

export const columnsStyles: ProductListColumnsStyles = {
    container: {
        gap: 15,
        css: css`
            margin-bottom: 30px;
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 4, 3, 3],
        css: css`
            padding: 0 20px 0 0;
            flex-wrap: wrap;
            align-items: flex-start;
            flex-direction: column;
            @media (max-width: 768px) {
                padding: 0 10px;
            }
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 8, 9, 9],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding-left: 0;
                    `,
                    css`
                        padding-left: 0;
                    `,
                    css`
                        padding-left: 0;
                    `,
                ])}
        `,
    },
    categoryLinkListWrapper: {
        css: css`
            width: 100%;
            border: 1px solid #d6d6d6;
            height: 250px;
            overflow-y: auto;
            padding: 10px 0 0 10px;
            flex-wrap: wrap;
            align-items: flex-start;
            flex-direction: column;
            @media (max-width: 768px) {
                margin-bottom: 20px;
            }
        `,
    },
    categoryListWrapper: {
        css: css`
            width: 100%;
        `,
    },
};

const styles = columnsStyles;

const CategoryListColumns: FC<WidgetProps> = ({ id }) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftColumnGridItem}>
                <StyledWrapper {...styles.categoryLinkListWrapper}>
                    <StyledWrapper {...styles.categoryListWrapper}>
                        <Zone contentId={id} zoneName="Content00" />
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.rightColumnGridItem}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: CategoryListColumns,
    definition: {
        group: "Product List",
        displayName: "Category List Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
